import React, { ReactNode } from 'react';

import {
  DataGridPageAction,
  DataGridPageContextProvider,
  DataGridPageContextProviderProps,
  DataGridPageState,
  defaultDataGridPageReducer,
  useDataGridPageContext,
} from 'shared/DataGridPageContext';

import { InsightResolutionRow } from './types';

type InsightResolutionsPageState = DataGridPageState<InsightResolutionRow>;
type InsightResolutionsPageAction = DataGridPageAction<InsightResolutionRow>;

const insightResolutionsPageReducer = defaultDataGridPageReducer<
  InsightResolutionRow,
  InsightResolutionsPageState,
  InsightResolutionsPageAction
>;

export interface InsightResolutionsContextProviderProps
  extends Pick<
    DataGridPageContextProviderProps<InsightResolutionRow>,
    'initialStateOverrides'
  > {
  children: ReactNode;
}

export const InsightResolutionsContextProvider = ({
  children,
  initialStateOverrides,
}: InsightResolutionsContextProviderProps) => {
  return (
    <DataGridPageContextProvider
      reducer={insightResolutionsPageReducer}
      initialStateOverrides={initialStateOverrides}
    >
      {children}
    </DataGridPageContextProvider>
  );
};

export const useInsightResolutionsContext = () => {
  return useDataGridPageContext<InsightResolutionRow>();
};
